import { Result } from 'antd';

export function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="La página que buscás no existe."
    />
  );
}
